<template>
  <div class="dropdown" @mousedown="(e) => e.preventDefault()">
    <div class="dropdown-header">
      <a-checkbox
        class="title"
        @change="handleChangeAll"
        v-model:checked="allChecked"
      ></a-checkbox>
      <span class="title-label" @click="handleChangeAll">{{ title }}</span>
    </div>

    <div class="dropdown-list">
      <div v-for="r in tRoles" :key="r" class="dropdown-list-item">
        <div class="dropdown-list-sub-title">
          <a-checkbox
            v-model:checked="checkeds[r]"
            :value="opt"
            class="dropdown-list-item-checkbox"
            @change="handleChangeSubAll(r)"
          ></a-checkbox>
          <span class="dropdown-list-item-label" @click="handleChangeSubAll(r)">
            {{ r }}
          </span>
        </div>
        <a-checkbox-group v-model:value="values[r]">
          <div v-for="l in list[r]" :key="l" class="dropdown-list-item">
            <a-checkbox
              :value="l.level"
              class="dropdown-list-item-checkbox"
            ></a-checkbox>
            <span
              class="dropdown-list-item-label"
              @click="handleClickCheckboxLabel(r, l.level)"
            >
              {{ l.level }}
            </span>
          </div>
        </a-checkbox-group>
      </div>
    </div>

    <!-- <a-tree
      v-model:model:expandedKeys="expandedKeys"
      v-model:selectedKeys="selectedKeys"
      v-model:checkedKeys="checkedKeys"
      checkable
      :tree-data="treeData"
    ></a-tree> -->

    <div class="dropdown-actions">
      <a-button type="link" class="clear" @click="handleClear">
        Clear All
      </a-button>
      <a-button class="cancel" @click="handleCancel">Cancel</a-button>
      <a-button type="primary" @click="handleApply">Apply</a-button>
    </div>
  </div>
</template>

<script>
import { toRaw } from 'vue'
export default {
  name: 'DashboardTreeDropdownRender',
  props: {
    title: {
      type: String,
    },
    list: {
      type: Array,
    },
    tRoles: {
      type: Array,
    },
    tValues: {
      type: Array,
    },
    type: {
      type: String,
    },
    selected: {
      type: Array,
    },
  },
  data() {
    return {
      brandRoles: [],
      values: [],
      checkeds: [],
    }
  },
  mounted() {
    this.values = { ...this.tValues }

    this.checkeds = this.tRoles
      .map((e) => ({ [e]: true }))
      .reduce((prev, next) => {
        return { ...prev, ...next }
      }, {})
  },
  computed: {
    allChecked() {
      const len1 = Object.values(this.tValues)
        .map((e) => e.length)
        .reduce((prev, next) => {
          return prev + next
        }, 0)
      const len2 = Object.values(this.values)
        .map((e) => e.length)
        .reduce((prev, next) => {
          return prev + next
        }, 0)

      return len1 == len2
    },
  },
  watch: {
    values: {
      handler(newVal) {
        Object.keys(newVal).map((e) => {
          this.checkeds[e] = this.values[e].length === this.tValues[e].length
        })
      },
      deep: true,
    },
    selected: {
      handler(newVal) {
        this.values = this.selected
      },
    },
  },
  methods: {
    handleChangeAll() {
      if (!this.allChecked) {
        this.values = { ...this.tValues }
      } else {
        this.handleClear()
      }
    },
    handleChangeSubAll(r) {
      if (this.tValues[r].length === this.values[r].length) {
        let c = { ...this.values }
        c[r] = []
        this.values = { ...c }
      } else {
        this.values[r] = [...this.tValues[r]]
      }
    },
    handleClear() {
      this.values = Object.keys(this.values)
        .map((e) => ({ [e]: [] }))
        .reduce((prev, next) => {
          return { ...prev, ...next }
        }, {})
    },
    handleCancel() {
      this.$emit('cancel', false, this.type)
    },
    handleApply() {
      this.$emit('query', this.values, this.type)
    },
    handleClickCheckboxLabel(r, l) {
      if (this.values[r].includes(l)) {
        this.values[r] = this.values[r].filter((e) => e !== l)
      } else {
        this.values[r] = [...this.values[r], l]
      }
    },
  },
}
</script>

<style lang="less" scoped>
.dropdown {
  &-header {
    .title {
      padding: 12px;

      &-label {
        font-weight: 700;
        font-size: 14px;
        color: black;
        cursor: pointer;
      }
    }
  }

  &-list {
    max-height: 300px;
    overflow-y: scroll;
    padding: 12px;

    &-sub-title {
      color: black;
      margin-bottom: 12px;

      &-label {
        margin-left: 12px;
        cursor: pointer;
        font-weight: normal;
      }
    }

    &-item {
      margin-bottom: 12px;
      margin-left: 12px;

      &-checkbox {
        margin-right: 12px;
      }

      &-label {
        cursor: pointer;
        font-weight: normal;
      }
    }
  }

  &-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #f0f0f0;

    .clear {
      margin-right: 16px;
    }

    .cancel {
      margin-right: 16px;
    }
  }
}
</style>
